<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-romaplus">
      <div class="px-3 col-3 p-0">
        <div class="heading-romaplus">{{ $t("result.round") }}</div>
        <div class="text-subhead-romaplus">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-romaplus">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-romaplus">
          {{ (data.bet) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-romaplus">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-romaplus">
          {{ (data.winlose) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-romaplus">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-romaplus">
          {{ (data.balance) | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-romaplus pt-3">
      <div class="text-game-romaplus">Roma Plus</div>
      <div class="text-subgame-romaplus">{{ $t("romaplus.name") }}</div>

      <div class="text-subgame-romaplus">
        {{ data.detail.type.replace('_', ' ') }}
      </div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <section v-if="data.detail.type === 'BONUS_GAME'" class="d-flex justify-content-between align-content-center">
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="isFreeSpin" class="fas fa-caret-left arrow-side-romaplus" @click="delCount()"></i>
        </div>
        <div class="text-center pt-4">
          <img
            :src="require(`../../assets/resultGame/romaplus/bonus/item_${[2, 3].includes(data.detail.bonusGamePerform) ? 2 : data.detail.bonusGamePerform}.png`)"
            alt="" />
          <h2 class="bonus-wining d-flex justify-content-center align-items-center mx-auto mt-5">
            <span>{{ data.detail.winning ? '+' : '' }}</span>
            <span>{{ (data.detail.winning) | currencyFormatter }} {{ currency }}</span>
          </h2>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!data.detail.isEndRound" class="fas fa-caret-right arrow-side-romaplus" @click="addCount()"></i>
        </div>
      </section>
      <section v-else>
        <div class="col-12 justify-content-center d-flex flex-row p-0">
          <div class="col-1 d-flex align-items-center justify-content-center">
            <i v-if="isFreeSpin" class="fas fa-caret-left arrow-side-romaplus" @click="delCount()"></i>
          </div>
          <div class="all-table-romaplus container d-flex flex-column justify-content-center">
            <table>
              <tbody>
                <tr v-for="(row, index) in data.detail.symbols[0]" :key="index">
                  <td v-for="(col, i) in data.detail.symbols" :key="`${index}${i}`" class="p-0">
                    <img class="icon-symbol" :src="require(`../../assets/resultGame/romaplus/symbol_${col[index]
                      }.png`)
                      " alt="" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-1 d-flex align-items-center justify-content-center">
            <i v-if="!data.detail.isEndRound" class="fas fa-caret-right arrow-side-romaplus" @click="addCount()"></i>
          </div>
        </div>
        <div v-if="data.freeSpin" class="text-subgame-romaplus mb-1">
          {{
            $t('result.freespin') +
            ' ' +
            data.detail.freeSpinsPlayed +
            '/' +
            data.detail.freeSpinsCount
          }}
        </div>
        <div class="col-12 justify-content-center d-flex flex-row">
          <hr class="line col-3" />
          <div class="text-detail align-items-center d-flex px-3">
            {{ $t("result.detail") }}
          </div>
          <hr class="line col-3" />
        </div>

        <div v-if="data.detail.featureBuy || isFreeSpin" class="text-subgame-romaplus">Feature Buy</div>

        <div class="col-12 justify-content-center d-flex flex-row mt-4">
          <div class="bet-box-romaplus p-2 px-3">
            <div class="bet-warpper item" v-for="(detail, index) in data.detail.winCombos" :key="index">
              <div class="d-flex item justify-content-between px-1 mb-2">
                <div class="bet-wrapper-romaplus item">
                  <div class="d-flex justify-content-start bet-wrapper-romaplus item">
                    <div class="d-flex flex-column align-items-start justify-content-center">
                      <p class="my-1 yellow">
                        {{ `Line ${detail[0] + 1}` }}
                      </p>
                    </div>
                    <img class="icon-detail-hcl" :src="require(`../../assets/resultGame/romaplus/symbol_${detail[1]
                      }.png`)
                      " alt="" />
                    <div class="d-flex flex-column align-items-start justify-content-center">
                      <p class="my-1 yellow">
                        {{ `${detail[2]} ` + $t("result.kind") }}
                      </p>
                    </div>
                    <div class="d-flex flex-column justify-content-center px-3">
                      <p class="my-1">{{ currency }} {{ data.detail.winnings[index] | currencyFormatter }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bet-warpper item" v-if="data.detail.winShowsCount === 0">
              <div class="d-flex justify-content-between mt-5">
                <div class="bet-wrapper-romaplus item align-content-center d-flex">
                  <div class="d-flex justify-content-center bet-wrapper-romaplus item align-content-center p-3">
                    <p class="my-1 red">{{ "No Winnings" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-ghost",
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      currency: this.data.currency ? (this.data.detail.isCoin ? 'AMS' : this.data.currency) : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreeSpin: (!this.data.detail.type === 'SPIN' && !this.data.detail.isEndRound) || this.data.count
    };
  },
  async created() {
    if (!this.currency.includes("(")) {
      this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName(
        "header"
      )[0].offsetHeight;
    },
    async addCount() {
      const countData = this.data.count + 1;
      this.$emit("fetchResult", countData);
    },
    async delCount() {
      const countData = this.data.count - 1;
      this.$emit("fetchResult", countData);
    },
  },
};
</script>

<style scoped>
.bonus-wining {
  width: 230px;
  height: 70px;
  background-color: #A11010;
  border-radius: 14px;
  color: #FFE463;
}

.icon-detail-hcl {
  width: 90px;
  padding: 10px;
  height: 90px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-romaplus {
  cursor: pointer;
  color: #cac095;
  text-align: center;
  font-size: 90px;
}

.bet-box-romaplus {
  background: #000000;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-romaplus .item {
  color: #fff;
  background: #a11010;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #a11010;
}

.bet-box-romaplus .bet-wrapper-romaplus:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-romaplus,
.result-wrapper {
  font-size: 35px;
}

.header-romaplus {
  background: #a11010;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-romaplus {
  color: #ffe463;
  text-align: center;
}

.content-result-romaplus {
  background: #391818;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-romaplus {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-game-romaplus {
  text-shadow: 0px 0px 20px #ffe463;
  color: #ffe463;
  font-weight: bold;
  font-size: 25px;
  text-align: center;
}

.text-subhead-romaplus {
  font-size: px;
  color: white;
  text-align: center;
}

.text-subgame-romaplus {
  font-size: 20px;
  color: white;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #c7b873;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol {
  width: 100%;
}

.bet-box-romaplus {
  min-width: 600px;
  max-width: auto;
}

.all-table-romaplus {
  background: url("~@/assets/resultGame/romaplus/romaplus_frame.png") no-repeat;
  background-size: 770px 670px;
  width: 770px;
  height: 590px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  padding-top: 60px;
}

@media screen and (max-width: 1030px) {
  .all-table-romaplus {
    background-size: 700px 600px;
    width: 700px;
    height: 550px;
    padding-top: 20px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-romaplus {
    font-size: 60px;
  }

  .bet-box-romaplus {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-romaplus,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {
  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-romaplus,
  .result-wrapper {
    font-size: 33px;
  }
}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.yellow {
  color: #ffe463;
}

@media screen and (max-width: 770px) {
  .heading-romaplus {
    font-size: 18px;
  }

  .all-table-romaplus {
    background-size: 540px 460px;
    width: 540px;
    height: 420px;
    padding-top: 20px;
  }

  .text-subhead-romaplus {
    font-size: 18px;
  }

  .arrow-side-romaplus {
    font-size: 50px;
  }

  .bet-box-romaplus {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-romaplus {
    font-size: 12px;
  }

  .all-table-romaplus {
    background-size: 305px 250px;
    width: 305px;
    height: 230px;
    padding-top: 10px;
  }

  .text-subhead-romaplus {
    font-size: 14px;
  }

  .bet-box-romaplus {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper-romaplus,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-hcl {
    width: 60px;
    height: 60px;
    padding: 5px;
  }
}
</style>
